import { jsx as _jsx } from "react/jsx-runtime";
import { descriptionId, getTemplate, getUiOptions } from '@rjsf/utils';
/** The `ArrayFieldDescriptionTemplate` component renders a `DescriptionFieldTemplate` with an `id` derived from
 * the `idSchema`.
 *
 * @param props - The `ArrayFieldDescriptionProps` for the component
 */

export default function ArrayFieldDescriptionTemplate(props) {
  var idSchema = props.idSchema,
      description = props.description,
      registry = props.registry,
      schema = props.schema,
      uiSchema = props.uiSchema;
  var options = getUiOptions(uiSchema, registry.globalUiOptions);
  var _options$label = options.label,
      displayLabel = _options$label === void 0 ? true : _options$label;

  if (!description || !displayLabel) {
    return null;
  }

  var DescriptionFieldTemplate = getTemplate('DescriptionFieldTemplate', registry, options);
  return _jsx(DescriptionFieldTemplate, {
    id: descriptionId(idSchema),
    description: description,
    schema: schema,
    uiSchema: uiSchema,
    registry: registry
  });
}